import React, {FC} from 'react';
import {Checkbox, FormControlLabel, Link, Typography} from "@mui/material";
import {getAgreementUrl} from "../util/BookingUtil";
import {styled} from "@mui/material/styles";

const TosAgreementLink = styled(Link)(({theme}) => ({
  textDecoration: "none",
  fontSize: "inherit",
  color: theme.palette.secondary.main,
}));

interface TosAgreementLabelProps {
  agreementUrl: string;
}

const TosAgreementLabel = ({agreementUrl}: TosAgreementLabelProps) => {
  return (
    <Typography component={'span'}>
      I accept the <TosAgreementLink href={agreementUrl} target="_blank" rel="noopener noreferrer">Rental
      Agreement</TosAgreementLink>.
    </Typography>
  );
};

interface RentalAgreementCheckboxProps {
  id?: string,
  name?: string,
  checked: boolean,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  required?: boolean,
  classes?: { formControlLabel?: string, checkbox?: string },
  /** Booking-specific rental agreement (e.g. `getAgreementUrl(booking)`). Defaults to the SecurSpace reservation agreement. */
  agreementUrl?: string,
}

const RentalAgreementCheckbox: FC<RentalAgreementCheckboxProps> = ({
                                                                     id,
                                                                     name,
                                                                     checked,
                                                                     onChange,
                                                                     required,
                                                                     classes,
                                                                     agreementUrl = getAgreementUrl(),
                                                                   }) => {
  return (
    <FormControlLabel
      className={classes?.formControlLabel || "ss-checkbox"}
      label={<TosAgreementLabel agreementUrl={agreementUrl}/>}
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          id={id || "agreementAccepted"}
          name={name || "agreementAccepted"}
          required={required}
          className={classes?.checkbox || "ss-checkbox"}
        />
      }
    />
  );
};

export default RentalAgreementCheckbox;
